import { cn } from "@/domains/library"

export const ScaleInnerCard100 = ({
  children,
  className,
  onClick,
  style,
  enabled = false,
}: {
  children: React.ReactNode
  className?: string
  enabled?: boolean
  style?: React.CSSProperties
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    if (onClick) {
      onClick(event)
    }
  }
  const s: React.CSSProperties = {
    opacity: 0.7,
    ...style,
  }
  if (enabled === true) {
    s.opacity = 1
  }

  return (
    <div
      className={cn(
        "sc-inner-card-100",
        "rounded-lg",
        "transition-all duration-300 ease-in-out",
        "border",
        enabled ? "bg-p100 hover:bg-p100-light" : "bg-p100-shade hover:bg-p100",
        enabled ? "border-p100-shade" : "border-p200-light",
        className,
      )}
      data-enabled={enabled ? "true" : "false"}
      style={s}
      onClick={handleClick}
    >
      {children}
    </div>
  )
}
